import noop from 'lodash/noop';

// Prevents classing with default Object properties, such as `prototype`
const constructKey = key => `_${key}`;

export class StorageFallback {
  constructor() {
    let data = {};

    this.getItem = key => data[constructKey(key)];
    this.setItem = (key, value) => {
      data[constructKey(key)] = String(value);
    };
    this.removeItem = key => {
      delete data[constructKey(key)];
    };
    this.clear = () => {
      data = {};
    };
    // Consider caching
    Object.defineProperty(this, 'length', {
      get: () => Object.keys(data).length,
      configurable: false,
      enumerable: false,
    });
  }
}

export const buildStorageFallback = () => new StorageFallback();

export function getLocalStorage() {
  try {
    localStorage.setItem('TESTxMattersTEST', '1');
    noop(localStorage.getItem('TESTxMattersTEST'));
    localStorage.removeItem('TESTxMattersTEST');

    return localStorage;
  } catch (e) {
    // Build a simple fallback wrapper:
    return buildStorageFallback();
  }
}

export const xmLocalStorage = getLocalStorage();
window.xmLocalStorage = xmLocalStorage;

export function getSessionStorage() {
  try {
    sessionStorage.setItem('TESTxMattersTEST', '1');
    noop(sessionStorage.getItem('TESTxMattersTEST'));
    sessionStorage.removeItem('TESTxMattersTEST');

    return sessionStorage;
  } catch (e) {
    // Build a simple fallback wrapper:
    return buildStorageFallback();
  }
}

export const xmSessionStorage = getSessionStorage();
window.xmSessionStorage = xmSessionStorage;

export default xmLocalStorage;
